import styled, { css } from 'styled-components';
import { SYS_SPACE_FIXED_100 } from '@oneaudi/unified-web-common';
import { device } from '../../styles/devices';

export const SpecWrapper = styled.div<{ isResponsive?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${SYS_SPACE_FIXED_100};

  ${({ isResponsive }) => {
    if (isResponsive) {
      return css`
        width: 298px;
        min-width: 298px;
        max-width: 350px;
      `;
    }
    return css`
      width: 277px;
    `;
  }}
`;

/**
 * Layout
 */
export const Wrapper = styled.div`
  padding: 0 18px;
  padding-top: 48px;
  padding-bottom: 48px;
  @media ${device.tablet} {
    padding: 48px 32px 60px;
  }
  @media ${device.laptopL} {
    padding: 48px 48px 40px 60px;
    margin: 0 auto;
  }
`;
